module.exports = __webpack_public_path__ + "img/icon-lack-creativity.216d8d5e.svg";